import { Button } from "@itandi/itandi-bb-ui/Button";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import clsx from "clsx";
import Link from "next/link";
import React from "react";
import { ConfirmModal } from "~/components/common/parts/modal/ConfirmModal";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import { useSummaryFileTemplates } from "~/hooks/useSummaryFileTemplates";
import type { SummaryFileTemplate } from "~/models/SummaryFileTemplate";
import { isSuccess } from "~/utils/api/api_handler";
import { destroy, getShowPath } from "~/utils/api/SummaryFileTemplate";
import Styles from "./SummaryFileTemplateRow.module.scss";

type Props = {
	template: SummaryFileTemplate;
};

export function SummaryFileTemplateRowUploaded({ template }: Props) {
	const { notify } = useNotification();
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	const { mutate } = useSummaryFileTemplates().useIndex();
	const handleAcceptDelete = React.useCallback(async () => {
		const response = await destroy(template.id);
		if (isSuccess(response)) {
			await mutate();
			notify({ content: "削除しました。", variant: "success" });
			return;
		}
		notify({
			content: `エラーが発生しました。${response.message}`,
			variant: "error"
		});
	}, [mutate, notify, template.id]);
	return (
		<div className={Styles.SettingContents}>
			<span className={clsx(Styles.SettingLabel, Styles.Uploaded)}>設定済</span>
			<Link
				className={Styles.Link}
				href={getShowPath(template.id)}
				target="_blank"
			>
				設定ファイル
			</Link>
			<Button height="small" onClick={handleOpen} variant="danger">
				削除
			</Button>
			<ConfirmModal
				confirmType="delete"
				handleAccept={handleAcceptDelete}
				handleCancel={handleClose}
				isOpen={isOpen}
			>
				削除してよろしいですか？
			</ConfirmModal>
		</div>
	);
}
